var isMotionValue = function isMotionValue(value) {
  return !!(value === null || value === void 0 ? void 0 : value.getVelocity);
};
export { isMotionValue };